/**
 * components/common/FooterSignature.tsx
 * App-wide footer signature as requested.
 */

import React from 'react'

/**
 * FooterSignature
 * Shows a small signature at the bottom of the app.
 */
export function FooterSignature() {
  return (
    <footer className="mt-8 border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-4 text-center text-sm text-slate-600">
        صنع بحب من مؤسسة ابعاد الإستراتيجية — سجل تجاري رقم 7051346430
      </div>
    </footer>
  )
}
